import React from "react";
import { Container, Row, Col, Button, Image } from "react-bootstrap";
import "./Convinience.css";
import Black_Btn from "../../common_component/common_btn/black_btn/Black_Btn";
import { useNavigate } from "react-router-dom";

function Convinience() {

  const navigate = useNavigate()

  return (
    <div className="convinience-section">
      <Container>
        <Row className="align-items-center">
          {/* LEFT TEXT */}
          <Col md={5} className="convinience-text order-2 order-md-1">
            <div className="content-holder">
              <h2 className="title_text">Convenience for All</h2>

              <p className="descn_text">
                At<span> PmRoad</span> we place your well-being & comfort above
                all else. Through continuous refinement of our safety systems,
                we strive to make sure every trip is secure and positive one for
                you.
              </p>

              <Black_Btn btnText={"KNOW MORE"} className="know-more-btn" onClick={() => {navigate("/about-us")}}/>
            </div>
          </Col>

          {/* RIGHT IMAGE (SINGLE FRAME IMAGE) */}
          <Col md={7} className="convinience-image order-1 order-md-2">
            <div className="content-Imageholder">
              <div className="right_img_holder">
                <img
                  src="./assets/images/about_us/Convinience.png"
                  alt="Convenience frame"
                  fluid
                  className="frame-img"
                />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Convinience;